import { Badge, Box, Flex, Modal, Text } from '@fullstory/components';
import { Event } from '@fullstory/proto/fs/api/segment';
import {
  ActivityMonitoring,
  ActivityMonitoringError,
  AuditEvent,
  DQMRow,
  VolumeTimeRange,
} from '@fullstory/proto/fs/services/dx-objects';
import { fullstorySelectors } from '@fullstory/redux';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { ActivityTab } from '../components/ActivitiyTab';
import { Tab, TabList } from '../components/TabList';
import css from './index.module.scss';

interface UseDqmTabsInput {
  name: string;
  desc: string;
  renderDetailTab: () => React.ReactNode;
  activityMonitoring:
    | {
        data: ActivityMonitoring | null;
        error: ActivityMonitoringError | null;
        timeRange: VolumeTimeRange;
        onTimeRangeChange: (x: VolumeTimeRange) => void;
      }
    | undefined;
  searchEvent: Event;
  objectType: string;
  auditHistory: AuditEvent[] | null;
  eventSupport: DQMRow.EventSupport;
}

const OCTOBER_TS = 1696132800 * 1000;

export function useDqmTabs({
  name,
  desc,
  renderDetailTab,
  activityMonitoring,
  searchEvent,
  objectType,
  auditHistory,
  eventSupport,
}: UseDqmTabsInput) {
  const showTabs = !!activityMonitoring;
  const [tab, setTab] = useState(0);
  const showDataDirect = useSelector(fullstorySelectors.getIsDataDirect);

  if (!showTabs) {
    return { content: <Modal.Body>{renderDetailTab()}</Modal.Body>, tab: 0 };
  }

  return {
    content: (
      <Box data-component="useDqmTabs" paddingLeft={16} paddingRight={16}>
        <Flex column alignItems="flex-start">
          <TabList
            data-component="useDqmTabs"
            selected={tab}
            onSelect={setTab}
            titles={[
              <Text
                appearance="bodyMediumBold"
                key="details"
                testId={`${objectType.toLowerCase()}-definition-details-tab`}
              >
                <FormattedMessage defaultMessage="Details" id="Lv0zJu" />
              </Text>,
              <Flex key="activity" gap={8} alignItems="center">
                <Text
                  appearance="bodyMediumBold"
                  testId={`${objectType.toLowerCase()}-definition-activity-tab`}
                >
                  <FormattedMessage defaultMessage="Activity" id="ZmlNQ3" />
                </Text>
                <Badge variant="brand">
                  <FormattedMessage defaultMessage="New" id="bW7B87" />
                </Badge>
              </Flex>,
            ]}
          >
            <Tab key="details">
              <div style={{ marginLeft: -16, marginRight: -16, marginTop: -15 }}>
                <div className={css.scrollShadows}>
                  <Modal.Body>{renderDetailTab()}</Modal.Body>
                </div>
              </div>
            </Tab>
            <Tab key="activity">
              <div style={{ marginLeft: -16, marginRight: -16, marginTop: -15 }}>
                <div className={css.scrollShadows}>
                  <Modal.Body>
                    <ActivityTab
                      name={name}
                      description={desc}
                      activityMonitoring={activityMonitoring!.data}
                      activityMonitoringError={activityMonitoring!.error}
                      timeRange={activityMonitoring!.timeRange}
                      onTimeRangeChange={activityMonitoring!.onTimeRangeChange}
                      searchEvent={searchEvent}
                      objectType={objectType}
                      monitoringStart={OCTOBER_TS}
                      auditHistory={auditHistory}
                      eventSupport={eventSupport}
                      showDataDirect={showDataDirect}
                    />
                  </Modal.Body>
                </div>
              </div>
            </Tab>
          </TabList>
        </Flex>
      </Box>
    ),
    tab,
  };
}
